import type { CapiProductPage } from 'types/capi/pdp';

import SizeInteractionEvent from '~/events/SizeInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

export default function useSizeInteraction() {
  const { isBot } = useRootData();
  const user = useUser();
  const product = usePageData<CapiProductPage>();

  return (selectedSize?: string) =>
    new SizeInteractionEvent({
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      productId: String(product.product_id),
      selectedSize
    }).send();
}
